// TODO: refactor this

import $ from 'jquery';
import { debugLog } from './enci.log.js';

/**
 * Provides an array of event sources for calendar integration, each configured with a Google Calendar ID and associated styling classes.
 * This configuration allows for the integration of multiple Google Calendars, each distinguished by a unique class for custom styling.
 * The 'className' property assigns a specific class to events from each calendar, facilitating theme-specific styling.
 * The 'eventClassNames' property applies additional custom classes to all events, enabling further customization.
 * This structured approach to managing event sources supports the dynamic presentation of calendar events from various Google Calendars within a unified interface.
 *
 * @function getEventSources
 * @returns {Array} An array of objects, each representing a configured event source for the calendar.
 */
export function getEventSources(classNameFilter = null) {
  const eventSources = [
    {
      googleCalendarId: '4kj3klpks8clusjvm7ti0ghsno@group.calendar.google.com',
      className: 'govt-alaska',
      eventClassNames: 'myclassname',
    },
    {
      googleCalendarId: '0l3lg3p5hjnthr7d876ac7pgic@group.calendar.google.com',
      className: 'govt-blm',
      eventClassNames: 'myclassname',
    },
    {
      googleCalendarId: 'reeoqehhpt8h8lahopnvc96164@group.calendar.google.com',
      className: 'govt-colorado-glo',
      eventClassNames: 'myclassname',
    },
    {
      googleCalendarId: 'uai3n6uef3cjnek75kksur6qlg@group.calendar.google.com',
      className: 'govt-new-mexico-glo',
      eventClassNames: 'myclassname',
    },
    {
      googleCalendarId: '51i4amt83ep5a0e9ps176rer84@group.calendar.google.com',
      className: 'govt-montana-dnrc',
      eventClassNames: 'myclassname',
    },
    {
      googleCalendarId: '7edn9dnc1olim7cvqovp6pm92o@group.calendar.google.com',
      className: 'govt-north-dakota-glo',
      eventClassNames: 'myclassname',
    },
    {
      googleCalendarId: '0l82a9s47f57fj3c5h93tlg4dg@group.calendar.google.com',
      className: 'govt-south-dakota-spl',
      eventClassNames: 'myclassname',
    },
    {
      googleCalendarId: '78ob6b0k48bsm7eimom3534ugg@group.calendar.google.com',
      className: 'govt-oklahoma-clo',
      eventClassNames: 'myclassname',
    },
    {
      googleCalendarId: 'vnctj9rgi9b58q490vdclmtt10@group.calendar.google.com',
      className: 'govt-texas-glo',
      eventClassNames: 'myclassname',
    },
    {
      googleCalendarId: '455hivr1d96ajgtbjfdgv49poo@group.calendar.google.com',
      className: 'govt-texas-unv-lands',
      eventClassNames: 'myclassname',
    },
    {
      googleCalendarId: 'u3q3j7i6kgi31g0ong8dtpbn2g@group.calendar.google.com',
      className: 'govt-utah-glo',
      eventClassNames: 'myclassname',
    },
    {
      googleCalendarId: 'kvid3goab7jd0clqjbpf6q1t8k@group.calendar.google.com',
      className: 'govt-wyoming-glo',
      eventClassNames: 'myclassname',
    },
    // California State Lands Commission
    {
      googleCalendarId:
        '78fa44335d75545daa51231821121eceef5681b69559723f5d5bac5e8aafcbc2@group.calendar.google.com',
      className: 'govt-california-state-lands-commission',
      eventClassNames: 'myclassname',
    },
    // City of Las Vegas
    {
      googleCalendarId:
        'fedbcb1454a6fdbd1351b21261f2cc57ac2280aeee1756f9b27e3255f6854eef@group.calendar.google.com',
      className: 'govt-city-of-las-vegas',
      eventClassNames: 'myclassname',
    },
    // Nevada Division of State Lands
    {
      googleCalendarId:
        '3ed0573b5f675f0e0eaefebe40ef9d1a16d7a9eeea850c895146f797b338ed42@group.calendar.google.com',
      className: 'govt-nevada-division-of-state-lands',
      eventClassNames: 'myclassname',
    },
  ];

  // If a classNameFilter is provided, filter the eventSources by className
  if (classNameFilter) {
    return eventSources.filter(
      (source) => source.className === classNameFilter
    );
  }

  // Otherwise, return the entire eventSources array
  return eventSources;
}
/**
 * Asynchronously initializes a list view FullCalendar for government-related events, using specific plugins for list rendering and Google Calendar integration.
 * Dynamically imports the necessary FullCalendar core and plugin modules, then configures the calendar for a '.demo-calendar-list' element.
 * Targets list-based event display, enhancing accessibility and clarity for events scheduled across various government segments.
 * Integrates multiple Google Calendar sources to aggregate and display events in a user-friendly list format, offering a consolidated view of all activities.
 * Utilizes a unified Google Calendar API key and fetches event sources from a designated function to populate the calendar.
 *
 * @async
 * @function loadGoogleCalendarGovtList
 */
export async function loadGoogleCalendarGovtList() {
  debugLog('loadGoogleCalendarGovtList');
  try {
    const { Calendar } = await import('@fullcalendar/core');
    const listPlugin = await import('@fullcalendar/list');
    const googleCalendarPlugin = await import('@fullcalendar/google-calendar');

    const calendarEl = document.querySelector('.demo-calendar-list');
    if (!calendarEl) {
      debugLog('loadGoogleCalendarGovtList >> No calendars found.', {
        type: 'error',
      });
      return;
    }

    // Assuming getEventSources is a method within your en module that returns the event sources
    const eventSources = getEventSources();

    const calendar = new Calendar(calendarEl, {
      themeSystem: 'standard', // or 'bootstrap5' if you're using Bootstrap 5
      plugins: [listPlugin.default, googleCalendarPlugin.default],
      initialView: 'listWeek',
      googleCalendarApiKey: 'AIzaSyBD1wEOU9IPQwXP3AAGSfheNbebWVmNRsA',
      eventSources: eventSources,
    });
    calendar.render();
  } catch (error) {
    debugLog(
      'loadGoogleCalendarGovtList >> Error loading Google Calendar Govt List',
      { type: 'error', obj: error }
    );
  }
}

/**
 * Asynchronously loads and initializes the FullCalendar with various plugins for displaying government-related events.
 * Dynamically imports necessary FullCalendar modules and configures the calendar with custom views, toolbar settings, and Google Calendar integration.
 * Applies a data-theme attribute to calendar events based on their associated class, specifically looking for classes that start with 'govt-' to apply thematic styling.
 * Additionally, configures an event click handler to open event details in a new popup window, enhancing user interaction.
 * Utilizes the 'getEventSources' function to fetch and integrate multiple Google Calendars, each representing different governmental segments or functions.
 *
 * @async
 * @function initGoogleCalendarGovt
 */
export async function initGoogleCalendarGovt(classNameFilter = null) {
  try {
    const { Calendar } = await import('@fullcalendar/core');
    const dayGridPlugin = await import('@fullcalendar/daygrid');
    const timeGridPlugin = await import('@fullcalendar/timegrid');
    const listPlugin = await import('@fullcalendar/list');
    const multimonthPlugin = await import('@fullcalendar/multimonth');
    const googleCalendarPlugin = await import('@fullcalendar/google-calendar');

    debugLog('initGoogleCalendarGovt');
    const calendarEl = document.querySelector('.demo-calendar');

    if (!calendarEl) {
      debugLog('initGoogleCalendarGovt >> No calendars found.', { type: 'error' });
      return;
    }

    const sources = getEventSources(classNameFilter);

    debugLog('initGoogleCalendarGovt >> Sources:', { obj: sources });
    debugLog('initGoogleCalendarGovt >> classNameFilter:', { obj: classNameFilter });

    const calendar = new Calendar(calendarEl, {
      plugins: [
        dayGridPlugin.default,
        timeGridPlugin.default,
        listPlugin.default,
        googleCalendarPlugin.default,
        multimonthPlugin.default,
      ],
      headerToolbar: {
        left: 'prev,next today',
        center: 'title',
          right: 'dayGridMonth,multiMonthYearStack,listWeek',
      },
      views: {
        multiMonthYearStack: {
          type: 'multiMonthYear',
          buttonText: 'Year',
          multiMonthMaxColumns: 1,
        },
        dayGridMonth: { buttonText: 'Month' },
        timeGridWeek: { buttonText: 'Week' },
        timeGridDay: { buttonText: 'Day' },
        listWeek: { buttonText: 'List' },
      },
      themeSystem: 'standard',
      initialView: 'dayGridMonth',
      googleCalendarApiKey: 'AIzaSyBD1wEOU9IPQwXP3AAGSfheNbebWVmNRsA',
      eventSources: sources,
      eventDidMount: function (info) {
        let eventEl = info.el;
        let appliedClass = '';

        eventEl.classList.forEach((className) => {
          if (className.startsWith('govt-')) {
            appliedClass = className;
          }
        });

        eventEl.setAttribute('data-theme', appliedClass);
      },
      eventClick: function (arg) {
        window.open(arg.event.url, '_blank', 'width=700,height=600');
        arg.jsEvent.preventDefault();
      },
    });
    calendar.render();
  } catch (error) {
    debugLog('Error loading Google Calendar Govt', {
      type: 'error',
      obj: error,
    });
  }
}
/**
 * Enhances interactivity by applying hover effects to agency links and buttons, highlighting associated calendar events.
 * When hovering over items in the agency list or buttons within the agency button group, corresponding events in both the calendar and list view are highlighted.
 * This function facilitates a visual connection between agencies and their events, improving the user experience by making it easier to identify related events.
 * Additionally, commented-out code suggests a potential feature for dynamically equalizing the heights of the calendar and list views for consistent presentation.
 *
 * @function setHoverHighlight
 */
export async function setHoverHighlight() {
  // debugLog('setHoverHighlight');

  const agencyList = $('.agency-list a');
  const agencyBtnGroup = $('.agency-btn-group button.btn-primary');

  $(agencyList).on('mouseenter mouseleave', function () {
    // debugLog('setHoverHighlight >> agencyList mouseenter');
    const filterID = $(this).attr('id');
    $(this).toggleClass('highlighted');

    $(`#government-calendar a.fc-event.${filterID}`)
      .toggle()
      .toggleClass('highlighted');

    // filter list maybe?
    $(`#government-calendar-list .fc-list-item.${filterID}`)
      .toggle()
      .toggleClass('highlighted');
  });

  $(agencyBtnGroup).on('mouseenter mouseleave', function () {
    // debugLog('setHoverHighlight >> agencyBtnGroup mouseenter');
    const filterID = $(this).attr('id');
    $(this).toggleClass('pressed');

    $(`#government-calendar a.fc-event.${filterID}`).toggleClass('highlighted');
    // filter list maybe?
    $(`#government-calendar-list .fc-list-item.${filterID}`).toggleClass(
      'highlighted'
    );
  });
}